// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"c6603fd3","420":"68bf26dd","539":"6a19752c","637":"899f618d","644":"a42f262a","775":"c42064dc","857":"e4eda24a","884":"1f880aea","945":"00c7d6a9"}[chunkId] + ".js";
};